import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

interface AiStarsIconProps extends IconProps {
  width?: number;
  height?: number;
  color?: string;
  loading?: boolean;
}

const AiStarsIcon = ({
  width = 24,
  height = 24,
  color = '#EBDD4C',
  loading = false,
  ...props
}: AiStarsIconProps) => (
  <SvgComponent width={width} height={height} viewBox='0 0 24 24' {...props}>
    <mask
      id='mask0_2776_5433'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='24'
      height='24'
    >
      <rect width='24' height='24' fill='white' />
    </mask>
    <g mask='url(#mask0_2776_5433)'>
      <path
        className={loading ? 'ai-star-3' : ''}
        d='M8.31833 1.00011C8.4918 0.567672 9.10396 0.567673 9.27742 1.00011L10.4384 3.89436C10.4832 4.00607 10.5656 4.09863 10.6714 4.15606L13.3352 5.60248C13.6954 5.79805 13.6954 6.31504 13.3352 6.51061L10.6714 7.95703C10.5656 8.01446 10.4832 8.10702 10.4384 8.21873L9.27742 11.113C9.10396 11.5454 8.4918 11.5454 8.31833 11.113L7.15736 8.21873C7.11255 8.10702 7.03014 8.01446 6.92437 7.95703L4.26057 6.51061C3.90039 6.31504 3.90039 5.79805 4.26057 5.60248L6.92437 4.15606C7.03014 4.09863 7.11255 4.00607 7.15736 3.89436L8.31833 1.00011Z'
        fill={color}
      />
      <path
        className={loading ? 'ai-star-1' : ''}
        d='M8.6294 13.9995C8.80416 13.5705 9.41169 13.5705 9.58644 13.9995L10.6159 16.527C10.6614 16.6386 10.7444 16.7309 10.8507 16.7877L13.2161 18.0526C13.5801 18.2473 13.5801 18.7692 13.2161 18.9639L10.8507 20.2288C10.7444 20.2856 10.6614 20.3778 10.6159 20.4895L9.58644 23.0169C9.41169 23.446 8.80416 23.446 8.6294 23.0169L7.59996 20.4895C7.55449 20.3778 7.47141 20.2856 7.3651 20.2288L4.99975 18.9639C4.6357 18.7692 4.6357 18.2473 4.99975 18.0526L7.3651 16.7877C7.47141 16.7309 7.55449 16.6386 7.59996 16.527L8.6294 13.9995Z'
        fill={color}
      />
      <path
        className={loading ? 'ai-star-2' : ''}
        d='M16.2246 11.1071C16.3993 10.6779 17.0071 10.6779 17.1818 11.1071L17.866 12.7881C17.9114 12.8997 17.9945 12.992 18.1007 13.0488L19.7271 13.9192C20.091 14.1139 20.091 14.6356 19.7271 14.8303L18.1007 15.7007C17.9945 15.7575 17.9114 15.8498 17.866 15.9614L17.1818 17.6424C17.0071 18.0717 16.3993 18.0717 16.2246 17.6424L15.5405 15.9614C15.495 15.8498 15.412 15.7575 15.3057 15.7007L13.6793 14.8303C13.3155 14.6356 13.3155 14.1139 13.6793 13.9192L15.3057 13.0488C15.412 12.992 15.495 12.8997 15.5405 12.7881L16.2246 11.1071Z'
        fill={color}
      />
    </g>
  </SvgComponent>
);

export default AiStarsIcon;
